import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatMoney'
})
export class FormatMoneyPipe implements PipeTransform {

  transform(value: number | string, locale: string = 'pt-BR', currency: string = 'BRL'): string {
    if (value === null || value === undefined) return '';
    // Transforma o valor em um número se for uma string
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;

    // Utiliza o método toLocaleString para formatar o valor como moeda
    return numericValue.toLocaleString(locale, {
      style: 'currency',
      currency: currency
    });
  }
}
